import "../../styles/add-programme-launcher.css";

export default function AddProgrammeLauncher({
  isOpen,
  onClose,
  onSingleProgramme,
  onUploadCatalogue
}) {
  if (!isOpen) return null;

  return (
    <div className="admin-modal-overlay add-programme-modal-overlay">

      <div
        className="admin-modal add-programme-modal add-programme-launcher"
        role="dialog"
        aria-modal="true"
        aria-labelledby="add-programmes-title"
      >

        <div className="admin-modal-header launcher-header">

          <div>

            <h2 id="add-programmes-title">Add Programmes</h2>

            <p>
              Choose how you would like to add programmes to your university catalogue.
            </p>

          </div>

          <button
            type="button"
            className="admin-modal-close"
            onClick={onClose}
            aria-label="Close Add Programmes"
          >
            ×
          </button>

        </div>

        <div className="admin-modal-body launcher-body">

        <button
          type="button"
          className="launcher-card"
          onClick={onSingleProgramme}
        >

          <div className="launcher-icon">
            ➕
          </div>

          <div className="launcher-content">

            <h3>Single Programme</h3>

            <p>
              Create one programme manually.
            </p>

          </div>

        </button>

        <button
          type="button"
          className="launcher-card"
          onClick={onUploadCatalogue}
        >

          <div className="launcher-icon">
            📂
          </div>

          <div className="launcher-content">

            <h3>Upload Programme Catalogue</h3>

            <p>
              Import multiple programmes from a CSV or Excel file.
            </p>

          </div>

        </button>

        </div>

        <div className="admin-modal-footer admin-modal-actions">

          <button
            type="button"
            className="secondary-btn"
            onClick={onClose}
          >
            Cancel
          </button>

        </div>

      </div>

    </div>
  );
}
